import {DEFAULT_SQL_TEMPLATE_FORM_STATE} from './sql-template-form/SQLTemplateFormConstants';
import {FormType, SQLTemplateFormState} from './sql-template-form/SQLTemplateFormTypes';

export enum InsightsBlockEditorActionType {
  INSIGHTS_DELETE_SQL_TEMPLATE_FORM = 'INSIGHTS_DELETE_SQL_TEMPLATE_FORM',
  INSIGHTS_UPDATE_SQL_TEMPLATE_FORM = 'INSIGHTS_UPDATE_SQL_TEMPLATE_FORM',
  INSIGHTS_UPDATE_SQL_QUERY_OVERRIDE = 'INSIGHTS_UPDATE_SQL_QUERY_OVERRIDE',
  INSIGHTS_RESET_SQL_QUERY_OVERRIDE = 'INSIGHTS_RESET_SQL_QUERY_OVERRIDE',
}

interface InsightsDeleteSQLTemplateFormAction {
  type: InsightsBlockEditorActionType.INSIGHTS_DELETE_SQL_TEMPLATE_FORM;
  analyticsQueryId: string;
}

interface InsightsUpdateSQLTemplateFormAction {
  type: InsightsBlockEditorActionType.INSIGHTS_UPDATE_SQL_TEMPLATE_FORM;
  analyticsQueryId: string;
  sqlTemplateFormState: SQLTemplateFormState;
}

interface InsightsUpdateSQLQueryOverride {
  type: InsightsBlockEditorActionType.INSIGHTS_UPDATE_SQL_QUERY_OVERRIDE;
  analyticsQueryId: string;
  sqlQueryOverride: string;
}

interface InsightsResetSQLQueryOverride {
  type: InsightsBlockEditorActionType.INSIGHTS_RESET_SQL_QUERY_OVERRIDE;
  analyticsQueryId: string;
}

export function deleteSQLTemplateForm(analyticsQueryId: string): InsightsDeleteSQLTemplateFormAction {
  return {
    type: InsightsBlockEditorActionType.INSIGHTS_DELETE_SQL_TEMPLATE_FORM,
    analyticsQueryId,
  };
}

export function initializeSQLTemplateForm(
  analyticsQueryId: string,
  formType: FormType
): InsightsUpdateSQLTemplateFormAction {
  return {
    type: InsightsBlockEditorActionType.INSIGHTS_UPDATE_SQL_TEMPLATE_FORM,
    analyticsQueryId,
    sqlTemplateFormState: {...DEFAULT_SQL_TEMPLATE_FORM_STATE, formType},
  };
}

export function updateSQLTemplateForm(
  analyticsQueryId: string,
  sqlTemplateFormState: SQLTemplateFormState
): InsightsUpdateSQLTemplateFormAction {
  return {
    type: InsightsBlockEditorActionType.INSIGHTS_UPDATE_SQL_TEMPLATE_FORM,
    analyticsQueryId,
    sqlTemplateFormState,
  };
}

export function updateSQLQueryOverride(
  analyticsQueryId: string,
  sqlQueryOverride: string
): InsightsUpdateSQLQueryOverride {
  return {
    type: InsightsBlockEditorActionType.INSIGHTS_UPDATE_SQL_QUERY_OVERRIDE,
    analyticsQueryId,
    sqlQueryOverride,
  };
}

export function resetSQLQueryOverride(analyticsQueryId: string): InsightsResetSQLQueryOverride {
  return {
    type: InsightsBlockEditorActionType.INSIGHTS_RESET_SQL_QUERY_OVERRIDE,
    analyticsQueryId,
  };
}

export type InsightsBlockEditorAction =
  | InsightsDeleteSQLTemplateFormAction
  | InsightsUpdateSQLTemplateFormAction
  | InsightsUpdateSQLQueryOverride
  | InsightsResetSQLQueryOverride;
